module.exports = __webpack_public_path__ + "img/mango-header-logo.9a592da3.png";